import axios from 'axios'
import { BACKEND_URL_STORE } from '@constants/server.constant'

export const listAnnouncements = async () => {
  return await axios.get(`${BACKEND_URL_STORE}/announcement`)
}
